@if (errorVisible) {
    @for (errorInput of messageConfig; track $index) {
        @if (input?.errors && input?.errors?.[errorInput.code]) {
            <span class="m-0 message-mat-error"> {{ errorInput.message }} </span>
        }
    }
}
